import styles from "./ActScreenProduceTransformationFromMachineAdjustmentConfirmationButtons.module.scss";
import confirmationStyles from "../../Components/ActionScreenConfirmationButton.module.scss";
import { IonButton } from "@ionic/react";
import useHxfTranslation from "../../../../../../../barrel/hooks/useHxfTranslation";

interface IProps {
  onClickConfirm: any;
  enabled: any;
}

function ActScreenProduceTransformationFromMachineAdjustmentConfirmationButtons(props: IProps) {
  const {t} = useHxfTranslation();
  
  return (
    <div className={styles.container}>
      <div className={styles.lineBreaker}></div>
      <div className={styles.buttonsContainer}>
        <div className={confirmationStyles.confirmationContainer}>
          <IonButton
          data-btn={"confirm-transf"}
            disabled={props?.enabled ? !props.enabled : true}
            className={confirmationStyles.confirmButton}
            onClick={() => {
              if (props.onClickConfirm) {
                props.onClickConfirm();
              }
            }}
          >
            { t("confirm")}
          </IonButton>
        </div>
      </div>
    </div>
  );
}

export default ActScreenProduceTransformationFromMachineAdjustmentConfirmationButtons;
